module.exports = __webpack_public_path__ + "img/uy.uy2a4ff39.svg";